import { Component, NgModule } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { CommonModule } from '@angular/common';
import { Storage } from '@ionic/storage';

import { GlobalsSingleton } from '../../app/core/GlobalsSingleton';
import { SearchTabletPage } from '../search/Tablet/search';
import { eGENA_Checkliste } from '../../visionet/Checkliste';
import { eGENA_ItemListe } from '../../visionet/ItemListe';
import { eGENA_KarteireiterTyp } from '../../visionet/KarteireiterTyp';

import { GlobalConstants } from '../../app/core/GlobalConstants';


@Component({
	selector: 'page-checklist',
	templateUrl: 'checklist.html',
})

@NgModule({
	imports: [
		CommonModule
	]
})


export class ChecklistPage {

	checkliste : eGENA_Checkliste; // Diese Checkliste wird hier angezeigt
	aktuellAngezeigteZusatzinformationen: string = ""; // Diese zusätzlichen Infromationen (Zusatzinformationen zum Item, CROm, Symptome, Differentialdiagnosen) werden gerade angezeigt.
	kareteireiterSymptomeDifferentialdiagnosenCRMs : string[] = ["CRM"]; // Karteireiter für Symptome und Differentialdiagnosen und die beerühmten CRMs
	aktuellAngezeigterKareteireiterSymptomeDifferentialdiagnosenCRMs : Map<eGENA_KarteireiterTyp, string> = new Map(); // Dieser Karteireiter wurde angeklickt damit die obigen Zusatzinformationen angezeigt werden.
	itemListen: Array<eGENA_ItemListe> = [];
	zeigeZusatzinformationenKarteireiter : Map<string, boolean> = new Map();
	isloaded: boolean = false;
	aktuelleItemListe: eGENA_ItemListe | undefined = undefined

	crms : any; // Wir verwenden hier explizit NICHT die Klasse eGENA_CRMs sondern behandeln dieses Attribut wie ein assoziatives array = letztlich ein JavaScript-Objekt


	searchType: string = ''
	curPatientType = ""


	constructor(public navCtrl: NavController, public navParams: NavParams, public storage: Storage, public globals: GlobalsSingleton) {
		let checklistenId : string = navParams.get('checklisteId');
		let curSearchType = navParams.get('curSearchType');

		if (checklistenId == undefined) {
			checklistenId = "ch_1";
		}


		if (curSearchType != undefined) {
			this.searchType = curSearchType
		}

		this.storage.get(checklistenId).then((checklistData : eGENA_Checkliste) => {
			this.checkliste = eGENA_Checkliste.fromJSONstring(JSON.stringify(checklistData))[0];
			this.storage.get(GlobalConstants.STORAGE_KEY_TEILNEHMERSPEZIFISCHES).then((teilnehmerspezifisches) => {
				this.crms = teilnehmerspezifisches?.CRMs;
				this.prepareChecklist(checklistData);
			})
		});

		console.info("Checkliste mit ID " + checklistenId);
	}


	/**	=== Visionet(sl) ==========
	 *	Die Checkliste, die in einer der Trefferlisten der Suche angeklickt wurde wird zur Anzeige aufbereitet:
	 */
	prepareChecklist(checkliste : eGENA_Checkliste) : void {
		this.itemListen = checkliste.karteireiter;
		this.curPatientType = checkliste.patientengruppe
		this.aktuelleItemListe = this.itemListen[0]
		this.setCurItemList(this.itemListen[0])

		// Am Anfang werden immer die CRM angezeigt.
		this.handleClickRightButtons("CRM");

		if (checkliste.symptome != undefined)
			this.kareteireiterSymptomeDifferentialdiagnosenCRMs.push("Symptome");
		if (checkliste.differentialdiagnosen != undefined)
			this.kareteireiterSymptomeDifferentialdiagnosenCRMs.push("Differentialdiagnosen");
		this.isloaded = true;
	}


	/**	=== Visionet(sl) ==========
	 *	Ist einer der Itemlisten-Karteireiter aktiviert? Rückgabewert ist eine CSS-Klasse:
	 *	- "aktiv"
	 *	- ""
	 */
	isActive(karteireiterTyp : eGENA_KarteireiterTyp, karteireiter : eGENA_KarteireiterTyp) : string {
		if (karteireiterTyp == eGENA_KarteireiterTyp.itemlistenkarteireiter) {
			if (karteireiter == this.aktuelleItemListe.typ) {
				return 'aktiv';
			}
		}

		return "";
	}


	/**	=== Visionet(sl) ==========
	 *	Die Checkliste, die in einer der Trefferlisten der Suche angeklickt wurde
	 */
	goHome(event : UIEvent) : void {
		this.navCtrl.goToRoot(
				{
				animate : true,
				animation: "ios-transition"
			}
		);

	}


	/**	=== Visionet(sl) ==========
	 *	KLick auf einen der Karteireiter Sofortmaßnahmen/Diagnose/Therapie
	 */
	setCurItemList(karteireiter : eGENA_ItemListe) : void {
		this.aktuelleItemListe = karteireiter
		let rechterKarteireterFürDieseListe : string | undefined = this.aktuellAngezeigterKareteireiterSymptomeDifferentialdiagnosenCRMs.get(karteireiter.typ);
		if (!rechterKarteireterFürDieseListe) {
			// Wenn für den ausgewählten Karteireiter noch nichts auf der rechten Seite (CRMs etc.) angeklickt war
			this.handleClickRightButtons("CRM");
		}
		else {
			// Ansonsten den rechten Karteireiter wieder herstellen
			this.handleClickRightButtons(rechterKarteireterFürDieseListe);
		}
	}


	/**	=== Visionet(sl) ==========
	 *	Klick auf die seitlichen Karteireiter "CRM", "Symptome", "Differentialdiagnosen" bzw. initale Darstellung von CRM
	 */
	handleClickRightButtons(name: string) : void {
		//this.zeigeZusatzinformationenKarteireiter = false;
		this.aktuellAngezeigterKareteireiterSymptomeDifferentialdiagnosenCRMs.set(this.aktuelleItemListe.typ, name)
		if (name == "Symptome") {
			if (this.checkliste.symptome != undefined)
				this.aktuellAngezeigteZusatzinformationen = this.setzeHyperlinksInZusatzinformationenEin(this.checkliste.symptome);
			else
				this.aktuellAngezeigteZusatzinformationen = "";
		}
		else if (name == "Differentialdiagnosen") {
			if (this.checkliste.differentialdiagnosen != undefined) {
				this.aktuellAngezeigteZusatzinformationen = this.setzeHyperlinksInZusatzinformationenEin(this.checkliste.differentialdiagnosen);
			}
			else
				this.aktuellAngezeigteZusatzinformationen = "";
		}
		else if (name == "CRM") {

			this.aktuellAngezeigteZusatzinformationen = this.crms[this.aktuelleItemListe?.typ];
		}
		else if (name == "Zusatzinformationen") {
			// Wir zeigen die Zusatzinformationen des zuletzt angeklickten Items an
			for (const item of this.aktuelleItemListe.listenElemente) {
				if (item.zusatzinformationenWerdenAngezeigt) {
					this.aktuellAngezeigteZusatzinformationen = this.setzeHyperlinksInZusatzinformationenEin(item.zusatzinformationen);
				}
			}
		}
	}


	/**	=== Visionet(sl) ==========
	 *	Als Parameter erhalten wir die ID einer Checkliste und zu dieser Checkliste soll gewechselt werden
	 */
	oeffneAndereCheckliste(infoObject : {checklisteId:string}) : void {
		this.navCtrl.push(ChecklistPage, {
			checklisteId: infoObject.checklisteId,
			curPatientType: this.curPatientType
		},
		{
			animate : true,
			animation: "ios-transition"
		});
	}


	/**	=== Visionet(sl) ==========
	 *	Als Parameter erhalten wir die Zusatzinformationen eines Items und diese Zusatzinformationen sollen dargestellt werden.
	 */
	getAktuellAngezeigterKareteireiterSymptomeDifferentialdiagnosenCRMsCSS() : string {
		if (!this.aktuellAngezeigterKareteireiterSymptomeDifferentialdiagnosenCRMs.get(this.aktuelleItemListe.typ)) {
			return "";
		}
		return this.aktuellAngezeigterKareteireiterSymptomeDifferentialdiagnosenCRMs.get(this.aktuelleItemListe.typ)
	}

	/**	=== Visionet(sl) ==========
	 *	Als Parameter erhalten wir die Zusatzinformationen eines Items und diese Zusatzinformationen sollen dargestellt werden.
	 */
	setZusatzinformationen(infoObject : {zusatzinformationen:string}) :void {
		this.aktuellAngezeigterKareteireiterSymptomeDifferentialdiagnosenCRMs.set(this.aktuelleItemListe.typ, "Zusatzinformationen");
		this.zeigeZusatzinformationenKarteireiter.set(this.aktuelleItemListe.typ, true);

		this.aktuellAngezeigteZusatzinformationen = this.setzeHyperlinksInZusatzinformationenEin(infoObject.zusatzinformationen);
	}


	zusatzinformationenKarteireiterAnzeigen() : boolean {
		if (this.zeigeZusatzinformationenKarteireiter.has(this.aktuelleItemListe.typ))
			return this.zeigeZusatzinformationenKarteireiter.get(this.aktuelleItemListe.typ);
		return false;
	}


	private setzeHyperlinksInZusatzinformationenEin(zusatzinformationen : string) : string {
		/*	Jetzt müssen wir alle Links ersetzen.
		 *	Aus einem
		 *
		 *		#1
		 *
		 *	machen wir einen Link der Art
		 *
		 *		<a (click)="linkClick(1);">Titel der Ziel-Checkliste</a>
		 *
		 *	Dabei ist aber zu beachten, dass textile-js viele Sonderzeichen zu HTML-Entites umwandelt.
		 *	Aus
		 *
		 *		'
		 *
		 *	(Apostroph) wird dann leider
		 *
		 *		&#8217;
		 *
		 *	Das sieht dann aus wie ein Link (#8217) aus. Es muss also alles mit "&" vorne dran ignorieren wir.
		 */
		let regex = /(.)\#([0-9]+){(.*?)}(.)/gm
		return zusatzinformationen.replace(regex, (match, $1, $2, $3, $4) => {
			let zeichenVorher : string = $1;
			let ziffern : string = $2;
			let linkName : string = $3
			let zeichenNachher : string = $4;
			if (zeichenVorher == "&" && zeichenNachher == ";")
				return match;

			return `${zeichenVorher}<a class="linkToChecklist" data-checklisteId="${ziffern}">${linkName}</a>${zeichenNachher}`;
		});
	}


	handleBreadcrumbClick(level) : void {
		this.navCtrl.setRoot(SearchTabletPage, { "level": level, "curPatientType": this.curPatientType, "curSearchType": this.searchType });
	}


	/**	=== Visionet(sl) ==========
	 *	Für die Breadcrumb-Zeile wird aus der internen Repräsentation des Suchtyps `this.searchType` eine lesbare Darstellung generiert.
	 */
	getSearchType() : string {
		var readable = { "az": "Alphabetische Suche", "reanimation": "Reanimation", "abcde": "ABCDE-Suche", "bodynav": "Körpernavigator", "search": "Freitextsuche" };
		return readable[this.searchType];

	}


	/**	=== Visionet(sl) ==========
	 *	Für die Breadcrumb-Zeile wird aus der internen Repräsentation des Patiententyps `this.curPatientType` eine lesbare Darstellung generiert.
	 */
	getPatientType() : string {
		var readable = { "k": "Kind", "e": "Erwachsener", "s": "Schwangere" };
		return readable[this.curPatientType];
	}

}


// WEBPACK FOOTER //
// ./src/pages/checklist/checklist.ts